export default __webpack_public_path__ + "static/media/chooseProduct.e1dc468e.svg";